import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="members-quick-search"
export default class extends Controller {
  static targets = ["query"]

  connect() {
  }

  search() {
    const filterValue = this.queryTarget.value

    const currentParams = new URLSearchParams(window.location.search)
    const params = new URLSearchParams()
    const formData = new FormData(this.element)

    // Copy all existing parameters
    for (const [key, value] of currentParams.entries()) {
      params.append(key, value)
    }
    // form ones, too
    for (const [key, value] of formData.entries()) {
      params.append(key, value)
    }

    // Build URL with all parameters
    const url = `/members?${params.toString()}`

    // Update browser URL without a full page reload
    window.history.pushState({}, '', url)

    // Use fetch to get the filtered results
    fetch(url, {
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
        .then(response => response.text())
        .then(html => {
          Turbo.renderStreamMessage(html)
        })
        .catch(error => {
          console.error("Error fetching filtered results:", error)
        })
  }
}
